import { Injectable } from '@angular/core';
import AesBuilder from './cipher.builder';
import { CipherModel } from './cipher.model';

@Injectable({
  providedIn: 'root'
})
export class CipherService {
  // private builder = new AesBuilder('my-super-secret-key');
  // encrypt(data: string): any {
  //   return this.builder.encrypt(data);
  // }

  // decrypt(data: string): any {
  //   return this.builder.decrypt(data);
  // }
  private aesUtil = new AesBuilder(CipherModel.SERECT_KEY);
  
  async cipher(data:string){
      const json=JSON.stringify(data);
      return this.aesUtil.encrypt(data);
  }
  async encipher(data : any){
    return this.aesUtil.decrypt(data);
  }
  
  async cipherHashing(data: any){
    return this.aesUtil.hashValue(data);
  }

}
